const initialState = {
    "active": true,
    "list": null,
    "edited" :null
}

export default initialState;